import { useQueryClient } from "@tanstack/react-query";
import { leadApi } from "api/lead";
import { crmKeys } from "views/inbox/api/crm";
import { InputSize } from "shared/components";
import { AssigneeSelect as SharedAssigneeSelect } from "shared/components/Assignee";

interface AssigneeSelectProps {
  value?: number | null;
  rowId?: string;
  propertyId?: number;
  inputClassName?: string;
  labelClassName?: string;
  onChange?: (assignee_id: number | null) => void;
  label?: string;
  size?: InputSize;
  searchable?: boolean;
}

export const AssigneeSelect = ({
  value,
  rowId,
  propertyId,
  inputClassName,
  labelClassName,
  onChange,
  label,
  size,
  searchable
}: AssigneeSelectProps) => {
  const queryClient = useQueryClient();

  const handleAssign = async (row_id: string, assignee_id: number | null) => {
    const lead = await leadApi.assignLead({
      lead_id: Number(row_id),
      assignee_ids: assignee_id !== null ? [assignee_id] : []
    });
    queryClient.setQueryData(crmKeys.leadDetails(row_id), lead);
    return lead;
  };

  const handleAssignSuccess = () => {
    queryClient.refetchQueries({ queryKey: ["LEAD_ACTIVITY_LOG"] });
    queryClient.refetchQueries({ queryKey: ["LEADS_TABLE"] });
    if (rowId) queryClient.refetchQueries({ queryKey: ["LEAD", rowId] });
  };

  return (
    <SharedAssigneeSelect
      value={value}
      rowId={rowId}
      propertyId={propertyId}
      labelClassName={labelClassName}
      inputClassName={inputClassName}
      onChange={onChange}
      onAssign={handleAssign}
      onAssignSuccess={handleAssignSuccess}
      label={label}
      size={size}
      searchable={searchable}
      successMessage="Lead assigned successfully"
      errorMessage="Failed to assign lead"
    />
  );
};
